$(document).ready(function() {
    // Multi-step form handling
    var currentStep = 0;
    var steps = $(".form-step");
    
    // Show first step
    showStep(currentStep);
    
    function showStep(step) {
        // Update form steps
        steps.removeClass("active");
        steps.eq(step).addClass("active");
        
        // Update progress indicators
        $(".step-wizard-item").removeClass("active completed");
        
        // Mark completed steps
        for (var i = 0; i < step; i++) {
            $(".step-wizard-item").eq(i).addClass("completed");
        }
        
        // Mark current step
        $(".step-wizard-item").eq(step).addClass("active");
    }
    
    // Next/Previous handlers
    $(".next-step").click(function() {
        if(validateStep(currentStep)) {
            currentStep++;
            showStep(currentStep);
        }
    });
    
    $(".prev-step").click(function() {
        currentStep--;
        showStep(currentStep);
    });

    // Form submission
    $("#multiStepForm").submit(function(e) {
        e.preventDefault();
        
        const submitBtn = $(this).find('button[type="submit"]');
        submitBtn.prop('disabled', true);
        submitBtn.html('<span class="spinner-border spinner-border-sm"></span> Sending...');

        // Build JSON structure
        const formData = {
            email: $("#email").val(),
            subject: "Moving Quote Request",
            intent: "moving_quote_request",
            body_content: {
                form_id: "FORM_" + Date.now(),
                streetAddressFrom: $("#streetAddressFrom").val(),
                zipCodeFrom: $("#zipCodeFrom").val(),
                cityFrom: $("#cityFrom").val(),
                countryFrom: $("#countryFrom").val(),
                cityTo: $("#cityTo").val(),
                countryTo: $("#countryTo").val(),
                name: $("#name").val(),
                phone: $("#phone").val(),
                movingDate: $("#movingDate").val(),
                message: $("#message").val(),
                urlSource: window.location.hostname || 'intl-movers.net'
            }
        };

        // Determine if we're in local development
        const isLocalDev = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
        
        // Set appropriate endpoint
        const endpoint = isLocalDev ? 'http://localhost:8787' : 'https://lead-form-handler.intl-movers.net';

        // Debug logging
        console.log('Sending data to:', endpoint);
        console.log('Form data:', formData);

        $.ajax({
            url: endpoint,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData),
            success: function(response) {
                console.log('Success response:', response);
                // In local dev, redirect to local thank-you page
                const thankYouUrl = isLocalDev ? '/thank-you.html' : 'https://intl-movers.net/thank-you#typ';
                window.location.href = thankYouUrl;
            },
            error: function(xhr, status, error) {
                console.error('Submission error:', {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    responseText: xhr.responseText,
                    error: error
                });
                
                // Show user-friendly error message
                submitBtn.prop('disabled', false);
                submitBtn.html('Submit');
                alert('An error occurred while submitting the form. Please try again.');
                
                // Log extra debug info
                if (xhr.responseText) {
                    try {
                        const errorDetails = JSON.parse(xhr.responseText);
                        console.error('Server error details:', errorDetails);
                    } catch (e) {
                        console.error('Raw error response:', xhr.responseText);
                    }
                }
            }
        });
    });

    // Validation per step
    function validateStep(step) {
        var valid = true;
        var inputs = steps.eq(step).find('input[required], select[required]');
        
        inputs.each(function() {
            if(!$(this).val()) {
                $(this).addClass('is-invalid');
                valid = false;
            } else {
                $(this).removeClass('is-invalid');
            }
        });
        
        return valid;
    }

    function nextStep() {
        const currentStep = document.querySelector('.form-step.active');
        const nextStep = currentStep.nextElementSibling;
        if (nextStep) {
            currentStep.classList.remove('active');
            nextStep.classList.add('active');
        }
    }

    function prevStep() {
        const currentStep = document.querySelector('.form-step.active');
        const prevStep = currentStep.previousElementSibling;
        if (prevStep) {
            currentStep.classList.remove('active');
            prevStep.classList.add('active');
        }
    }
}); 